import { useState, useCallback } from "react";
import { setToken, clearToken } from "../api";

export function useAuth() {
  const [isLoggedIn, setIsLoggedIn] = useState(
    () => !!localStorage.getItem("dashboard_token")
  );

  const login = useCallback(async (password) => {
    const res = await fetch("/api/auth/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ password }),
    });
    if (!res.ok) {
      // 401 = wrong password; 429 = locked out, and the server says for how long.
      const body = await res.json().catch(() => ({}));
      throw new Error(body.error || "Invalid password");
    }
    const { token } = await res.json();
    setToken(token);
    setIsLoggedIn(true);
  }, []);

  // Accept a token minted server-side (Google OAuth callback redirect).
  const loginWithToken = useCallback((token) => {
    setToken(token);
    setIsLoggedIn(true);
  }, []);

  const logout = useCallback(() => {
    clearToken();
    setIsLoggedIn(false);
  }, []);

  return { isLoggedIn, login, loginWithToken, logout };
}
